import { css } from 'styled-components'

import { MEDIA_QUERY } from './constants'
import { PrefixedUnion } from './mediaProperties'


export type TextAlign = 'right' | 'left' | 'center' | 'justify'

interface TextAlignBaseProps {
  textAlign?: TextAlign
}

export interface TextAlignProps
  extends TextAlignBaseProps,
    Partial<Record<PrefixedUnion<'sm', keyof TextAlignBaseProps>, TextAlign>> {}

export const textAlign = (props: TextAlignProps) =>
  css`
    text-align: ${props.textAlign ?? 'inherit'};
    @media ${MEDIA_QUERY.MOBILE} {
      text-align: ${props['sm-textAlign'] ?? props.textAlign ?? 'inherit'};
    }
  `
